import { TicketFileDto } from '@sib/api';
import { Card } from '@sib/ui';
import { DocumentItem } from './DocumentItem';
import { DocumentNoItems } from './DocumentNoItems';

interface DocumentsTabProps {
  documents?: TicketFileDto[];
}

export const DocumentsTab = ({ documents }: DocumentsTabProps) => (
  <div className="flex flex-col gap-3 p-3">
    <Card className="h-full flex-1 overflow-hidden p-3 sm:p-[22px]">
      <div className="flex h-full flex-col space-y-4">
        {documents && documents.length > 0 ? (
          documents.map(file => <DocumentItem file={file} />)
        ) : (
          <DocumentNoItems />
        )}
      </div>
    </Card>
  </div>
);
